/** Identidad pública compartida por el HTML, el cliente y el sitemap. */
export const PUNTOPY_SITE_ORIGIN = "https://puntopy.xyz";
export const PUNTOPY_SITE_NAME = "PuntoPY";
export const PUNTOPY_SITE_ALIASES = ["Punto Paraguay", "PuntoParaguay"];
export const PUNTOPY_SITE_IMAGE = "/icons/puntopy-512.png";
export const PUBLIC_SITE_PAGES = [
    {
        path: "/",
        title: "PuntoPY | Productos y comercios en Paraguay",
        description: "PuntoPY, Punto Paraguay: buscá productos y comercios por ciudad, consultá sus catálogos y disponibilidad, y contactá directamente a cada vendedor."
    },
    {
        path: "/descargar",
        title: "Instalar PuntoPY | Productos y comercios en tu dispositivo",
        description: "Instalá la aplicación web de PuntoPY en tu celular o computadora. Explorá productos y comercios de Paraguay desde la app o el navegador."
    },
    {
        path: "/privacidad",
        title: "Privacidad y protección de datos | PuntoPY",
        description: "Conocé cómo PuntoPY trata los datos de compradores y empresas, protege las cuentas y gestiona los catálogos publicados por sus responsables."
    },
    {
        path: "/terminos",
        title: "Condiciones de uso y publicación | PuntoPY",
        description: "Reglas para usar PuntoPY, publicar catálogos comerciales, reportar contenido y aplicar medidas de moderación en la plataforma."
    },
    {
        path: "/eliminar-cuenta",
        title: "Eliminar cuenta y datos | PuntoPY",
        description: "Cómo solicitar la eliminación de tu cuenta y los datos asociados a PuntoPY, con verificación de titularidad y sin compartir tu contraseña."
    }
];
export const PRIVATE_SITE_PREFIXES = ["/cuenta", "/ingresar", "/registro", "/mi-comercio", "/administracion", "/operaciones", "/incorporar"];
